<script lang="ts">
      import BlockWidth from '../blocks/BlockWidth.svelte'
import Image from './Image.svelte'

      let { block } = $props()
</script>

<BlockWidth>
  <Image image={block.image}></Image>
</BlockWidth>
